module.exports = new __parcel__URL__("19393_h.2dad71c3.jpg").toString();